import { Typography } from 'antd';
import { getCommunityReport } from '../utils/filerHandler';

const { Paragraph, Title } = Typography;

export default function CommunityReport({ id, reports }) {
  const community = getCommunityReport(id, reports) || {};

  return (
    <div className="community-header">
      <Title level={5} style={{ marginTop: 0 }}>{community.title || 'Community Details'}</Title>
      <Paragraph type="secondary" style={{ marginBottom: 0 }}>
        {community.summary || 'No description available.'}
      </Paragraph>
    </div>
  );
}
